import * as yup from 'yup';

export const helpSchema = yup.object({
  name: yup.string().required('Required'),
  email: yup.string().required('Required'),
  phone: yup.string().required('Required'),
});